import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df3d47bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "my-1 mr-3" }
const _hoisted_3 = { class: "d-flex flex-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-fill-space my-1" }, " Laden fehlgeschlagen ", -1))
const _hoisted_5 = { class: "flex-fill-space-minor my-1" }
const _hoisted_6 = { class: "d-flex flex-wrap justify-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-fill-space" }, null, -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorDisplay',
  props: {
  message: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ['retry'],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, { location: "bottom" }, {
    activator: _withCtx(({props, isActive}) => [
      (__props.message)
        ? (_openBlock(), _createBlock(_component_v_alert, _mergeProps({ key: 0 }, props, {
            type: "error",
            density: "compact",
            icon: false
          }), {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-alert")
                    ], undefined, true),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('retry')), ["stop"])),
                          size: "small",
                          loading: __props.loading,
                          block: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Erneut versuchen ")
                          ], undefined, true),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _hoisted_7,
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_icon, { class: "ml-3" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(isActive ? 'mdi-chevron-down' : 'mdi-chevron-up'), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ])
                ])
              ])
            ], undefined, true),
            _: 2
          }, 1040))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        color: "error-darken-1",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, { color: "grey-darken-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { style: {"white-space":"pre-line"} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.message), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }))
}
}

})